<template>
  <v-form>
    <v-container>
      <span v-if="editPumpTypeId == -1" class="headline">{{$t('create_pump_type')}}</span>
      <span v-if="editPumpTypeId != -1" class="headline">{{$t('edit_pump_type')}}</span>

      <v-row>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="pumpType.type" :label="$t('pump.pump_type')" required></v-text-field>
        </v-col>

        <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="pumpType.frequency" label="Frequency" suffix="Hz" required></v-text-field>
        </v-col> -->

        
      </v-row>
      <!-- <v-row> -->
        <!-- <v-col cols="12" md="3" lg="2" sm="4"> -->
<!--           
          <v-text-field
            v-model="pumpType.max_sand_quantity"
            suffix="gr/m^3"
            label="Max. Sand Quantity"
          ></v-text-field>
        </v-col> -->
<!--          
        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="pumpType.number_of_vane" suffix="" label="Number Of Vane"></v-text-field>
        </v-col> -->

        <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="pumpType.degree_of_protection" suffix="" label="Degree Of Protection"></v-text-field>
        </v-col> -->

        <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="pumpType.voltage" suffix="V" label="Voltage"></v-text-field>
        </v-col>
        
        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="pumpType.rotation" suffix="" label="Rotation"></v-text-field>
        </v-col> -->
        
      <!-- </v-row> -->

      <v-row>
        <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field
            v-model="pumpType.max_water_temp"
            suffix="C"
            label="Maximum Water Temp"
          ></v-text-field>
        </v-col> -->

        <!-- <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="pumpType.material" suffix="" label="Material"></v-text-field>
        </v-col>
           <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="pumpType.case" suffix="" label="Case"></v-text-field>
        </v-col>
        
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="pumpType.diffuser" suffix="" label="Diffuser"></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="pumpType.impeller" suffix="" label="Impeller"></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="pumpType.pump_shaft" suffix="" label="Pump Shaft"></v-text-field>
        </v-col> -->


        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="pumpType.fi_r" suffix="mm" :label="$t('pump.outside_diameter')"></v-text-field>
        </v-col>

        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="pumpType.fi_e" suffix='"' :label="$t('pump.outlet_diameter')"></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="pumpType.fi_shaft" suffix='mm' :label="$t('shaft_diameter')"></v-text-field>
        </v-col>



        <!-- <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="pumpType.coupling" suffix="" label="Coupling"></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="pumpType.strainer" suffix="" label="Strainer"></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="pumpType.valve_cap" suffix="" label="Valve Cap"></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="pumpType.connection" suffix="" label="Connection"></v-text-field>
        </v-col> -->
         
        
      </v-row>

       
      <div class="my-2">
        <v-btn color="primary" @click="savePumpType">{{$t('save')}}</v-btn>
        <v-btn class="mx-6" color="secondary" @click="savePumpType">{{$t('cancel')}}</v-btn>
      </div>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: "PumpTypesAdd",

  data: () => ({
    token: "",
    query: "",
    pumpType: {
      idpump_type: -1,
      type: "",
      frequency: "50", 
      max_sand_quantity : 200, 
      number_of_vane : 3,
      degree_of_protection : "IP 68",
      // voltage : "100-200",
      fi_shaft: "",
      fi_r : "",
      fi_e : "",
      rotation : "Clock Wise",
      max_water_temp : "30",
      material : "Stainless Steel",
      case : "Stainless Steel",
      diffuser : "Stainless Steel",
      impeller :  "Stainless Steel",
      pump_shaft  : "Stainless Steel",
      coupling :  "Stainless Steel",
      strainer :  "Stainless Steel",
      valve_cap : "Stainless Steel",
      connection : "Based on NEMA Standarts"
    } 
  }),

  props: {
    editPumpTypeId: {
      type: String,
      default: "-1"
    }
  },

  mounted: function() {
    if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
    if ( this.editPumpTypeId != -1){
        this.fetchPumpType(this.editPumpTypeId)
      }
  },
  methods: {
    fetchPumpType: function(editPumpTypeId) {
      this.$http.get(this.$API_URL + "pump_type?idpump_type=" + editPumpTypeId).then(result => {
        this.pumpType = result.data
      });
    },
    savePumpType: function() {
      var targetUrl = this.editPumpTypeId == -1 ? "save_pump_type" : "update_pump_type";

      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + targetUrl,
        data: this.pumpType
      })
        .then(function(response) {
          console.log(response.data)
          if (response.data == "1")
             window.history.go(-1)
        })
        .catch(function(error) {
          console.log(error);
        });
    },

     
  }
};
</script>
